import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: TestsState = {
    all: [],
    viewing: undefined,
    answers: {},
};

const rootState: TestsState = initialState;

const getters: GetterTree<TestsState, RootState> = {
    all(state: TestsState): Test[] {
        return state.all;
    },
    viewing(state: TestsState): Test | undefined {
        return state.viewing;
    },
};

const mutations: MutationTree<TestsState> = {
    RESET(state: TestsState) {
        state.all = [];
        state.viewing = undefined;
    },
    SET_TESTS(state: TestsState, payload: Test[]) {
        state.all = payload;
    },
    SET_TEST(state: TestsState, payload: Test) {
        state.viewing = payload;
    },
    SET_TEST_ANSWER(state: TestsState, payload: { data: TestQuestionAnswerResponse, slug: string }) {
        state.answers[payload.slug] = payload.data;
    },
};

const actions: ActionTree<TestsState, RootState> = {
    index({ commit, state }): any {

        // @ts-ignore
        return this._vm.$api.get(`tests`, { withCredentials: true })
            .then((response: { data: Test[] }) => {
                commit('SET_TESTS', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    read({ commit, state }, payload: string): any {

        if (state.viewing && state.viewing.slug === payload) {
            return state.viewing;
        }

        // @ts-ignore
        return this._vm.$api.get(`client-tests/${payload}`, { withCredentials: true })
            .then((response: { data: Test }) => {
                commit('SET_TEST', response.data);

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    createEntry({ commit }, payload: { slug: string, versionId: number, data: TestQuestionAnswer[] }): any {
        // @ts-ignore
        return this._vm.$api.post(`client-tests/${payload.slug}/versions/${payload.versionId}/entries`, { answers: payload.data }, { withCredentials: true })
            .then((response: { data: TestQuestionAnswerResponse }) => {
                commit('SET_TEST_ANSWER', { data: response.data, slug: payload.slug });

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
    readEntry({ commit, state }, payload: readEntryPayload): any {
        if (state.answers && state.answers[payload.slug] && state.answers[payload.slug].answers) {
            return new Promise((resolve) => resolve(state.answers[payload.slug]));
        }

        // @ts-ignore
        return this._vm.$api.get(`client-tests/${payload.slug}/versions/${payload.version}/entries/${payload.entryId}`, { withCredentials: true })
            .then((response: { data: TestQuestionAnswerResponse }) => {
                commit('SET_TEST_ANSWER', { data: response.data, slug: payload.slug });

                return Promise.resolve(response.data);
            })
            .catch((e: ErrorResponse) => {
                return Promise.reject(e);
            });
    },
};

export default {
    namespaced: true,
    state: rootState,
    getters,
    actions,
    mutations,
};
